import { useRef, useState } from "react";
import type { ReactNode } from "react";
import { useClickOutside } from "../../hooks";

interface DropdownMenuProps {
  trigger: ReactNode | ((open: boolean) => ReactNode);
  triggerClassName?: string;
  triggerLabel?: string;
  disabled?: boolean;
  align?: "left" | "right";
  panelClassName?: string;
  children: ReactNode | ((close: () => void) => ReactNode);
}

export default function DropdownMenu({
  trigger,
  triggerClassName = "",
  triggerLabel,
  disabled = false,
  align = "left",
  panelClassName = "",
  children,
}: DropdownMenuProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false), open);
  const close = () => setOpen(false);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={triggerLabel}
        className={triggerClassName}
      >
        {typeof trigger === "function" ? trigger(open) : trigger}
      </button>
      {open && (
        <div
          role="menu"
          className={`absolute top-full z-10 mt-1 rounded-lg border border-gray-200 bg-white shadow-md ${align === "right" ? "right-0" : "left-0"} ${panelClassName}`}
        >
          {typeof children === "function" ? children(close) : children}
        </div>
      )}
    </div>
  );
}
